<template>
  <v-list
    dense
    color="story-card__info-container transparent"
    class="text-left fill-height pa-0"
  >
    <v-list-item class="pa-0" three-line>
      <v-list-item-icon class="icon-container ma-0 mr-3">
        <img src="@/assets/icons/page.svg" alt="" />
      </v-list-item-icon>
      <v-list-item-content class="pa-0">
        <v-list-item-subtitle class="story-card__summary" v-html="summary" />
      </v-list-item-content>
    </v-list-item>
    <div class="d-flex flex-row align-center" style="gap: 30px">
      <v-slide-y-reverse-transition>
        <ListItemWithIcon
          v-show="!hideBottom"
          icon="location.svg"
          :title="startingLocationName"
        />
      </v-slide-y-reverse-transition>
      <v-slide-y-reverse-transition>
        <ListItemWithIcon
          v-show="!hideBottom"
          icon="calendar.svg"
          :title="publishedInfo(status, statusUpdatedAt)"
        />
      </v-slide-y-reverse-transition>
    </div>
  </v-list>
</template>
<script>
import ListItemWithIcon from "@/components/ListItemWithIcon";
import { STORY_STATUS } from "@/const";
export default {
  components: {
    ListItemWithIcon,
  },
  props: {
    status: String,
    statusUpdatedAt: String,
    _id: String,
    summary: String,
    location: String,
    name: String,
    hideBottom: Boolean,
    startChapter: Object,
  },
  computed: {
    STORY_STATUS() {
      return STORY_STATUS;
    },
    startingLocationName() {
      if (this.startChapter?.place?.name) {
        return this.startChapter.place.name;
      }
      return " - ";
    },
  },
  methods: {
    readableDate(dateString) {
      let date = new Date(dateString);
      return date.toDateString();
    },
    publishedInfo(status, statusUpdatedAt) {
      if (status == STORY_STATUS.Published) {
        let date = new Date(statusUpdatedAt);
        return date.toDateString();
      }
      return this.$t("storyHub.publishing.unpublished");
    },
  },
};
</script>
<style lang="scss" scoped>
.story-card__info-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.v-list .v-list-item {
  min-height: auto;
}

.v-list-item__content {
  max-height: 82px;
  min-height: auto;
  height: auto;
  display: block;
}

.v-list-item__icon.icon-container {
  height: 19px;
  width: auto;
  min-width: auto;
}

.summary-container {
  max-height: 90px;
}

.v-list-item .v-list-item__subtitle.story-card__summary {
  overflow: hidden;
  color: var(--v-secondaryText-base);
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  -webkit-line-clamp: 4;
}
</style>
